import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=4fc920bb&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=ts&"
export * from "./Legend.vue?vue&type=script&lang=ts&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=4fc920bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc920bb",
  null
  
)

export default component.exports